import { RelevanceType } from "types";
import styles from "./style.module.scss";
import classNames from "classnames";

const RelevanceTypeIcon = ({ type }: { type: RelevanceType }) => {
  const containerClassnames = classNames(styles.container, {
    [styles.h]: type === "High",
    [styles.m]: type === "Medium",
    [styles.l]: type === "Low",
  });

  return (
    <div className={styles.wrapper}>
      <div className={containerClassnames}></div>
      <span className={styles.text}>{type[0]}</span>
    </div>
  );
};

export default RelevanceTypeIcon;
